export const CHANGE_SELECTED_SERVICE_REQUEST =
  "CHANGE_SELECTED_SERVICE_REQUEST";
export const FETCH_SERVICE_REQUEST_SUCCESS = 'FETCH_SERVICE_REQUEST_SUCCESS';
export const FETCH_SERVICE_REQUEST_FAILED = 'FETCH_SERVICE_REQUEST_FAILED';
  